module.exports = __webpack_public_path__ + "img/gateway3.5a295e42.png";